import { render, staticRenderFns } from "./AccountAdditionalDetails.vue?vue&type=template&id=d913f6fc&"
import script from "./AccountAdditionalDetails.vue?vue&type=script&lang=js&"
export * from "./AccountAdditionalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports